import { FormSelect, Tab, Tabs } from '@tryhackme/thm-ui-components';
import { useEffect, useRef, useState } from 'react';
import { videos } from 'src/features/home/components/videos/videos.constants';
import { StyledCarousel, StyledCarouselContent, StyledDescription, StyledFormSelect, StyledFormSelectWrapper, StyledIFrame, StyledImage, StyledTabHeading, StyledTabList, StyledVideosSubtitle, StyledVideosTitle, StyledVideosWrapper } from 'src/features/home/components/videos/videos.styles';
import type { CarouselOption } from './videos.types';
export const Videos = () => {
  const tabRefs = useRef<(HTMLSpanElement | null)[]>([]);
  const [tabWidths, setTabWidths] = useState<number[]>([]);
  const [imageIndex, setImageIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(videos[0]);
  useEffect(() => {
    const widths = tabRefs.current.map((tab): number => tab?.offsetWidth ?? 0);
    setTabWidths(widths);
  }, []);
  const handleSelection = (option?: CarouselOption) => {
    if (option) {
      const index = videos.indexOf(option);
      setImageIndex(index);
      setSelectedOption(option);
    }
  };
  return <StyledVideosWrapper data-sentry-element="StyledVideosWrapper" data-sentry-component="Videos" data-sentry-source-file="videos.tsx">
      <StyledVideosTitle data-sentry-element="StyledVideosTitle" data-sentry-source-file="videos.tsx">Hands-on hacking for all skill levels</StyledVideosTitle>
      <StyledVideosSubtitle data-sentry-element="StyledVideosSubtitle" data-sentry-source-file="videos.tsx">Learn cyber security with fun gamified labs and challenges</StyledVideosSubtitle>
      <Tabs defaultValue={videos[0]?.label ?? 'Exercises in every lesson'} value={selectedOption?.label} data-sentry-element="Tabs" data-sentry-source-file="videos.tsx">
        <StyledTabList data-sentry-element="StyledTabList" data-sentry-source-file="videos.tsx">
          {videos.map(({
          id,
          label
        }, index) => <Tab key={id} value={label} asChild aria-label={`View media ${label}`} onClick={() => handleSelection(videos[index])}>
              <StyledTabHeading ref={el => {
            tabRefs.current[index] = el;
          }} tabWidth={tabWidths[index]}>
                {label}
              </StyledTabHeading>
            </Tab>)}
        </StyledTabList>
      </Tabs>
      <StyledFormSelectWrapper data-sentry-element="StyledFormSelectWrapper" data-sentry-source-file="videos.tsx">
        <StyledFormSelect data-sentry-element="StyledFormSelect" data-sentry-source-file="videos.tsx">
          <FormSelect isSearchable={false} options={videos} defaultValue={videos[0]} selected={selectedOption} handleSelection={handleSelection} forceDarkMode data-sentry-element="FormSelect" data-sentry-source-file="videos.tsx" />
        </StyledFormSelect>
      </StyledFormSelectWrapper>
      <StyledCarousel data-testid="media-carousel" aria-label="Media carousel" data-sentry-element="StyledCarousel" data-sentry-source-file="videos.tsx">
        {videos.map(({
        id,
        label,
        value,
        description
      }, index) => <StyledCarouselContent key={id}>
            {id === '4' ? <StyledImage src={value} alt={label} aria-hidden={imageIndex !== index} style={{
          translate: `${-100 * imageIndex}%`
        }} /> : <StyledIFrame title={label} allow="fullscreen; picture-in-picture" allowFullScreen src={value} aria-hidden={imageIndex !== index} style={{
          translate: `${-100 * imageIndex}%`
        }} />}
            <StyledDescription aria-hidden={imageIndex !== index} style={{
          translate: `${-100 * imageIndex}%`
        }}>
              {description}
            </StyledDescription>
          </StyledCarouselContent>)}
      </StyledCarousel>
    </StyledVideosWrapper>;
};